var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddCompany = function SvgAddCompany(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.2 3a.9.9 0 0 1 .9.9V9h-1.8V4.8H5.7v14.4h14.4V21h-18v-1.8h1.8V3.9a.9.9 0 0 1 .9-.9zm.97 7.219v2.858h2.86v1.905h-2.86v2.859h-1.904v-2.859h-2.859v-1.905h2.859V10.22h1.905ZM11.1 16.5H8.4v-1.8h2.7zm0-3.6H8.4v-1.8h2.7zm0-3.6H8.4V7.5h2.7z"
  })));
};
export default SvgAddCompany;